import styled, { css } from 'styled-components';

export default styled.a`
  height: 40px;
  font-family: 'Poppins', sans-serif;
  text-transform: none;
  font-size: 18px !important;
  color: white !important;
  &:hover {
    color: red !important;
  }
`;
